export const getSearchParam = (search) =>{
  return {
    start: new URLSearchParams(search).get('start'),
    end: new URLSearchParams(search).get('end'),
    counterparty: new URLSearchParams(search).get('id'),
    uncompleted: new URLSearchParams(search).get('unComp')=== 'true',
  }
}
